const hostname = window.location.hostname || ''

const isOnLocalhost = hostname === 'localhost' || hostname.startsWith('192.') || hostname.startsWith('172.') || hostname.startsWith('10.') || hostname.endsWith('ngrok.io')

export default isOnLocalhost
